import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Lenis from '@studio-freight/lenis';
import Home from './pages/Home';
import SolutionDetail from './pages/SolutionDetail';
import Careers from './pages/Careers';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import AntiFraudModal from './components/AntiFraudModal';
import './index.css';

function App() {
  useEffect(() => {
    // Make lenis globally accessible for programmatic scrolling
    window.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      window.lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      window.lenis.destroy();
      window.lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="bg-[#050505] min-h-screen text-white font-inter selection:bg-[#FFD700] selection:text-black">
        <Header />
        <AntiFraudModal />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions/:slug" element={<SolutionDetail />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
